import React, { useState, useEffect } from "react";
import EnquiryForm from "../components/EnquiryForm";
import EnquiryPopup from "../components/EnquiryPopup";
import BackBannerSection from "../components/BackBannerSection";
import BackhoeLoaderAuthorizedDealers from "../components/BackhoeLoaderAuthorizedDealers";
import BackhoeLoaderNewHeroCarousel from "../components/BackhoeLoaderNewHeroCarousel";
import BackhoeLoaderTabSection from "../components/BackhoeLoaderTabSection";
import BackhoeLoader from "../components/BackhoeLoader";
import { fetchPhoneNumberInformation } from "../services/api";
const BackhoePage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [phoneData, setPhoneData] = useState(null);
  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  useEffect(() => {
    const loadPhoneData = async () => {
      try {
        const data = await fetchPhoneNumberInformation();
        setPhoneData(data);
      } catch (error) {
        console.error('Error fetching phone number information:', error);
      }
    };

    loadPhoneData();
  }, []);
  return (
    <div>
      <BackhoeLoaderAuthorizedDealers />
      <BackhoeLoaderNewHeroCarousel phoneData={phoneData}/>
      <BackhoeLoaderTabSection />

        <section className="py-8 sm:py-16 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <EnquiryForm title={<>Need the<br className="hidden sm:block"/><span className="font-semibold">{" "}Right Backhoe Loader?</span></>} content={<><p className="text-lg lg:text-[22px] mb-8 text-white leading-relaxed">
            Get <span className="font-semibold">expert advice</span>, <span className="font-semibold">quick quotes</span>, and the <span className="font-semibold">best deals</span> — all in one place.
          </p>
          <p className="text-lg lg:text-[22px] mb-8 text-white leading-relaxed">
            Enquire now and let{" "}
            <span className="font-semibold">Golden Sparrow</span>
            <br className="hidden sm:block"/>
            {" "}lift your business higher.
          </p></>}
          backgroundImage="./images/backhoe/backhoeLoader_form.webp" tagLine={<p className="text-center text-sm sm:text-sm italic text-black mt-6 sm:mt-12 max-w-xs sm:max-w-sm md:max-w-[300px] mx-auto px-2">Get Your Backhoe Loader Price Today – Response <span className="font-semibold">within 1 hour</span></p>} />
      </div>
      </section>
     
    
 {/* Banner Section */}
      <section className="hidden sm:block back-bnrx py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-left sm:justify-start">
          <div className="max-w-max">
          <h2 className="text-2xl md:text-5xl lg:text-5xl font-normal text-white leading-normal mb-6">
            <span className="font-semibold">Backhoe Loaders</span>
          </h2>
          <p className="text-lg md:text-xl text-white leading-relaxed mb-8">Shortlisted backhoe loader that deliver powerful results.</p>
 
<ul className="flex flex-col gap-2 mb-6">
        <li className="text-white">
          <p className="flex items-center gap-2 mb-1">
            <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-4 text-black">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
            <span className="font-semibold">Lift more, move faster, save time</span>
          </p> 
        </li>
 
        <li className="text-white">
          <p className="flex items-center gap-2 mb-1">
            <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-4 text-black">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
            <span className="font-semibold">Dual-End Versatility</span>
          </p>
        </li>

        <li className="text-white">
          <p className="flex items-center gap-2 mb-1">
            <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="w-4 text-black">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </span>
            <span className="font-semibold">Built tough for any terrain.</span>
          </p>
        </li>
</ul>
 
{phoneData?.acf?.phone_backhoeloader && (
  <div className="flex flex-col sm:flex-row gap-4 mt-4">
    {/* <button onClick={handleOpenPopup} className="inline-flex items-center justify-center bg-[#FFC501] text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-3 rounded-md hover:bg-yellow-500 focus:bg-yellow-600 focus:outline-none focus:ring-4 focus:ring-yellow-300 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl" aria-label="Call to action button" >Request a quote</button> */}
    <a href={`tel:+${phoneData?.acf?.phone_backhoeloader}`} className="quoteNowBtn inline-flex items-center justify-center gap-3 text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-3 rounded-md focus:outline-none transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl" aria-label="Call to action button" ><span><img
                    src="/images/icons/phone_black.png"
                    alt=""
                    width="20"
                    height="20"
                  /></span>
                  <span>Get Quote Now</span></a>
  </div>
)}
 </div>          
        </div>
 
 
        <style>{`
            .back-bnrx {
    padding: 3em 0;
    background:url('./images/backhoe/backhoe_enq_1.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.quoteNowBtn {
            background: linear-gradient(
              159.21deg,
              #ffd200 11.19%,
              #f7971e 101.23%
            );
            outline: none;
            border: none;
          }

          .quoteNowBtn:hover,
          .quoteNowBtn:active {
            background: linear-gradient(
              159.21deg,
              #f7971e 11.19%,
              #ffd200 101.23%
            );
          }
 
@media screen and (max-width:768px){
.back-bnrx {
        background:url('./images/backhoe/backhoe_enq_1.webp');
        background-size: cover;
        background-position: center;
    }
}
       
        `}</style>
      </section>
      <BackhoeLoader phoneData={phoneData} />
 


      {/* Enquiry Popup */}
      <EnquiryPopup isOpen={isPopupOpen} onClose={handleClosePopup} />
    </div>
  );
};
export default BackhoePage;